import { useEffect } from 'react';
import useIsMobile from 'app/hooks/useIsMobile';

import useCustomization from './useCustomization';

export function useChatBubbleScrollBehavior(callback: (open: boolean) => void) {
  const customization = useCustomization();
  const isMobile = useIsMobile();

  // handle scroll
  useEffect(() => {
    const controller = new AbortController();
    const handleScroll = () => {
      if (!isMobile || customization?.open_button_fab_disable_transformations) {
        return;
      }

      window.setTimeout(() => {
        if (customization?.open_button_expand_on_scroll) {
          callback(true);
        } else if (customization?.auto_collapse) {
          callback(false);
        }
      }, 500);
    };

    window.addEventListener('scroll', handleScroll, { signal: controller.signal });

    return () => controller.abort();
  }, [customization, callback, isMobile]);
}
